<template>
    <v-container fluid class="pa-0">
        <v-row class="align-center pl-3">
            <!-- Breadcrumbs -->
            <v-breadcrumbs
                :items="[
                    { text: 'Home', disable: false, href: '/#/' },
                    { text: 'Cost Rates & Templates', disabled: true }
                ]"
                divider="/"
            ></v-breadcrumbs>
            <v-spacer />
        </v-row>

        <v-row class="ma-0" align="stretch">
            <!-- Business cost rates -->
            <v-col class="col-12 col-md-4" align="center">
                <v-card
                    outlined
                    elevation="3"
                    :loading="$apollo.queries.tenantGreenhouses.loading"
                >
                    <h5 class="text-center my-3">
                        <v-icon class="mr-1">water_damage</v-icon>Business Cost
                        Rates
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }"
                                ><v-icon small color="grey" v-on="on"
                                    >error_outline</v-icon
                                >
                            </template>
                            <span
                                >Greenhouse daily business cost (€ /
                                m2.day)</span
                            >
                        </v-tooltip>
                    </h5>
                    <v-divider></v-divider>
                    <div id="chart" class="mx-2">
                        <apexchart
                            type="line"
                            height="250"
                            :options="businessCostChartOptions"
                            :series="businessCostSeries"
                        ></apexchart>
                    </div>

                    <!-- bottom button -->
                    <v-list-item>
                        <v-spacer></v-spacer>
                        <v-btn
                            outlined
                            small
                            block
                            color="grey"
                            link
                            href="/#/operatingcosts"
                            >Edit</v-btn
                        >
                        <v-spacer></v-spacer>
                    </v-list-item>
                </v-card>
            </v-col>

            <!-- growth cost templates -->
            <v-col class="col-12 col-md-4" align="center">
                <v-card
                    outlined
                    elevation="3"
                    :loading="
                        $apollo.queries.tenantPlantFixedCostTemplates.loading
                    "
                >
                    <h5 class="text-center my-3">
                        <v-icon class="mr-1">spa</v-icon>Growth Cost Templates
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }"
                                ><v-icon small color="grey" v-on="on"
                                    >error_outline</v-icon
                                >
                            </template>
                            <span>Plant growth cost</span>
                        </v-tooltip>
                    </h5>
                    <v-divider></v-divider>

                    <v-expansion-panels class="grey lighten-4">
                        <v-expansion-panel
                            v-for="(item, i) in tenantPlantFixedCostTemplates
                                ? tenantPlantFixedCostTemplates
                                : []"
                            :key="i"
                        >
                            <v-expansion-panel-header class="pl-3 py-1">
                                <div>
                                    <v-chip color="primary" small class="mr-2"
                                        >{{
                                            item.node.potSize.potSizeCm
                                        }}cm</v-chip
                                    >
                                    {{ item.node.templateName }}
                                </div>
                                <v-spacer />
                                <div class="text-right mr-3">
                                    €{{ item.node.totalCost.toFixed(3) }}
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-divider></v-divider>
                                <v-list dense>
                                    <v-list-item
                                        v-for="(cost, index) in item.node
                                            .plantFixedCostTemplateItemSet
                                            .edges"
                                        :key="index"
                                    >
                                        <v-list-item-content class="subtitle-2"
                                            >{{ cost.node.itemName }}
                                        </v-list-item-content>
                                        <v-list-item-action
                                            class="subtitle-2 align-end"
                                        >
                                            €{{
                                                cost.node.costValue.toFixed(3)
                                            }}
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content class="subtitle-2"
                                            >Failure %
                                        </v-list-item-content>
                                        <v-list-item-action
                                            class="subtitle-2 align-end"
                                        >
                                            {{ item.node.failureRate * 100 }}%
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <!-- bottom button -->
                    <v-list-item>
                        <v-spacer></v-spacer>
                        <v-btn
                            outlined
                            small
                            block
                            color="grey"
                            link
                            href="/#/plantfixedcosttemplates"
                            >Edit</v-btn
                        >
                        <v-spacer></v-spacer>
                    </v-list-item>
                </v-card>
            </v-col>
            <!-- product cost templates -->
            <v-col class="col-12 col-md-4" align="center">
                <v-card
                    outlined
                    elevation="3"
                    :loading="
                        $apollo.queries.tenantProductFixedCostTemplates.loading
                    "
                >
                    <h5 class="text-center my-3">
                        <v-icon class="mr-1">local_florist</v-icon>Product Cost
                        Templates
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }"
                                ><v-icon small color="grey" v-on="on"
                                    >error_outline</v-icon
                                >
                            </template>
                            <span>Product packing, transport cost</span>
                        </v-tooltip>
                    </h5>
                    <v-divider></v-divider>

                    <v-expansion-panels class="grey lighten-4">
                        <v-expansion-panel
                            v-for="(item, i) in tenantProductFixedCostTemplates
                                ? tenantProductFixedCostTemplates
                                : []"
                            :key="i"
                        >
                            <v-expansion-panel-header>
                                <div>
                                    {{ item.node.templateName }}
                                </div>
                                <v-spacer />
                                <div class="text-right mr-3">
                                    €{{ item.node.totalCost.toFixed(3) }}
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-divider></v-divider>
                                <v-list dense>
                                    <v-list-item
                                        v-for="(cost, index) in item.node
                                            .productFixedCostTemplateItemSet
                                            .edges"
                                        :key="index"
                                    >
                                        <v-list-item-content class="subtitle-2"
                                            >{{ cost.node.itemName }}
                                        </v-list-item-content>
                                        <v-list-item-action
                                            class="subtitle-2 align-end"
                                        >
                                            €{{
                                                cost.node.costValue.toFixed(3)
                                            }}
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <!-- bottom button -->
                    <v-list-item>
                        <v-spacer></v-spacer>
                        <v-btn
                            outlined
                            small
                            block
                            color="grey"
                            link
                            href="/#/productfixedcosttemplates"
                            >Edit</v-btn
                        >
                        <v-spacer></v-spacer>
                    </v-list-item>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
// import moment from "moment";
import helper from "@/utils/helper.js";
import VueApexCharts from "vue-apexcharts";

export default {
    components: { apexchart: VueApexCharts },

    apollo: {
        tenantGreenhouses: {
            query: gql`
                query tenantGreenhouses {
                    tenantGreenhouses(orderBy: "name") {
                        edges {
                            node {
                                id
                                name
                                totalSpaceM2
                                operatingCostRateSet {
                                    edges {
                                        node {
                                            id
                                            month
                                            costPerM2Day
                                            totalCost
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {};
            },
            // result({ data, loading }) {
            //     if (!loading) {
            //         this.calculateOperatingCosts(
            //             data.tenantOperatingCosts.edges
            //         );
            //     }
            // },
            loadingKey: "loadingOperatingCostsKey",
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantGreenhouses.edges,
            skip: false
            // pollInterval: 60000 // ms
        },
        tenantPlantFixedCostTemplates: {
            query: gql`
                query tenantPlantFixedCostTemplates {
                    tenantPlantFixedCostTemplates {
                        edges {
                            node {
                                id
                                templateName
                                failureRate
                                totalCost
                                potSize {
                                    id
                                    potSizeCm
                                }
                                plantFixedCostTemplateItemSet(
                                    orderBy: "itemName"
                                ) {
                                    edges {
                                        node {
                                            id
                                            itemName
                                            costValue
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {};
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => {
                return data.tenantPlantFixedCostTemplates.edges.sort((a, b) => {
                    // first sort by greenhouse name, then sort by department name
                    if (a.node.potSize.potSizeCm == b.node.potSize.potSizeCm) {
                        return a.node.templateName.toLowerCase() ==
                            b.node.templateName.toLowerCase()
                            ? 0
                            : a.node.templateName.toLowerCase() >
                              b.node.templateName.toLowerCase()
                            ? 1
                            : -1;
                    } else {
                        return a.node.potSize.potSizeCm ==
                            b.node.potSize.potSizeCm
                            ? 0
                            : a.node.potSize.potSizeCm >
                              b.node.potSize.potSizeCm
                            ? 1
                            : -1;
                    }
                });
            },
            skip: false
            // pollInterval: 60000 // ms
        },
        tenantProductFixedCostTemplates: {
            query: gql`
                query tenantProductFixedCostTemplates {
                    tenantProductFixedCostTemplates {
                        edges {
                            node {
                                id
                                templateName
                                totalCost
                                productFixedCostTemplateItemSet(
                                    orderBy: "itemName"
                                ) {
                                    edges {
                                        node {
                                            id
                                            itemName
                                            costValue
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {};
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => {
                return data.tenantProductFixedCostTemplates.edges.sort(
                    (a, b) => {
                        return a.node.templateName.toLowerCase() ==
                            b.node.templateName.toLowerCase()
                            ? 0
                            : a.node.templateName.toLowerCase() >
                              b.node.templateName.toLowerCase()
                            ? 1
                            : -1;
                    }
                );
            },
            skip: false
            // pollInterval: 60000 // ms
        }
    },

    data() {
        return {
            monthNames: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],

            businessCostChartOptions: {
                chart: {
                    height: 250,
                    type: "line",
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    },
                    animations: {
                        enabled: false
                    }
                },
                yaxis: {
                    show: true,
                    title: {
                        text: "€ / m2.day"
                    },
                    labels: {
                        formatter: function(val) {
                            return `€ ${val.toFixed(3)}`;
                        }
                    },
                    min: 0
                },
                stroke: {
                    width: [2, 2, 2],
                    curve: "straight"
                }
            }
        };
    },
    computed: {
        businessCostSeries() {
            let _series = [];

            if (this.tenantGreenhouses) {
                _series = this.tenantGreenhouses.map(greenhouse => {
                    let _data = Array(12)
                        .fill(0)
                        .map((_, i) => {
                            const _cost = greenhouse.node.operatingCostRateSet.edges.find(
                                cost => {
                                    return cost.node.month == i + 1;
                                }
                            );

                            return _cost ? _cost.node.costPerM2Day : 0;
                        });

                    return {
                        name: greenhouse.node.name,
                        data: _data
                    };
                });
            }

            return _series;
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },
    methods: {
        getOperatingCostOfMonth(monthNumber) {
            if (!this.tenantOperatingCostRates) {
                return;
            }

            return this.tenantOperatingCostRates.tenantOperatingCostValueByMonth.edges
                .filter(item => {
                    return item.node.month === monthNumber;
                })
                .sort((a, b) =>
                    a.node.operatingCost.costName.localeCompare(
                        b.node.operatingCost.costName,
                        undefined,
                        { sensitivity: "base" }
                    )
                );
        }
    }
};
</script>